import { TreeMenuAction } from "../enums/TreeMenuAction";
import { SchemaTreeResult } from "../interfaces/SchemaTreeResult";
import { BeNeo4jService } from "../services/be-neo4j.service";
import FileSaver from 'file-saver';
import { generateCurrentDate, generateUUID } from "../utils/utils";
import { TaskNotificationService } from "../services/task-notification.service";
import { inject } from "@angular/core";
import { FILE_IMPORT_NOTIFICATION } from "../shared/strings";

export class SchemaTreeHandler {
  beNeo4jService: BeNeo4jService;
  callback: Function;
  retrieveDataSource: Function;
  taskNotificationService!: TaskNotificationService;

  IMPORT_STRINGS = FILE_IMPORT_NOTIFICATION;

  constructor(beNeo4jService: BeNeo4jService, callback: Function, retrieveDataSource: Function, taskNotificationService: TaskNotificationService) {
    this.beNeo4jService = beNeo4jService;
    this.callback = callback;
    this.retrieveDataSource = retrieveDataSource;
    this.taskNotificationService = taskNotificationService;
  }

  onSelectFromTree(result: SchemaTreeResult) {
    switch (result.type) {
      case TreeMenuAction.SHOW_NODES_FROM_HERE:
        this.beNeo4jService.getCypherById(result.schema.UUID!, result.schema.hierarchy).subscribe({
          next: (result: any) => {
            this.callback(result);
          }
        });
      break;
      case TreeMenuAction.SHOW_ONLY_CHILDS_CHAIN:
        this.beNeo4jService.getCypherById(result.schema.UUID!, result.schema.hierarchy, false).subscribe({
          next: (result: any) => {
            this.callback(result);
          }
        });
      break;
      case TreeMenuAction.SHOW_NODE:
        this.beNeo4jService.getNodeCypherById(result.schema.UUID!, result.schema.label).subscribe({
          next: (result: any) => {
            this.callback(result);
          }
        });
      break;
      case TreeMenuAction.SHOW_ONLY_CHILDS:
        this.beNeo4jService.getOnlyChildrenCypherById(result.schema.UUID!, result.schema.hierarchy).subscribe({
          next: (result: any) => {
            this.callback(result);
          }
        });
      break;
      case TreeMenuAction.EXPORT_TO_JSON:
        this.beNeo4jService.exportTaxonomyByHierarcht(result.schema.hierarchy).subscribe({
          next: (res: any) => {
            let finalName = `DXC_TWS_MODEL_[${result.schema.hierarchy}]_${generateCurrentDate()}_${generateUUID()}`;
            const jsonBlob = new Blob([JSON.stringify(res.result, null, 2)], { type: 'application/json' });
            FileSaver.saveAs(jsonBlob, finalName);
          }
        });
      break;
      case TreeMenuAction.IMPORT_JSON:
        this.taskNotificationService.trackObservable(this.beNeo4jService.importDataInDatabase(result.schema.UUID!, result.imported!), 
        this.IMPORT_STRINGS.importing_file, {
          pendingMessage: this.IMPORT_STRINGS.file_is_being_processed,
          successMessage: this.IMPORT_STRINGS.import_completed,
          errorMessage: this.IMPORT_STRINGS.import_error
        }).subscribe({
          next: (res: any)=>{
            this.retrieveDataSource();
          }
        });
      break;
      case TreeMenuAction.EXPORT_HYPERFLOWS_TO_JSON:
        this.beNeo4jService.exportHyperflows(result.schema.hierarchy).subscribe({
          next: (res: any)=>{
            let finalName = `DXC_TWS_HYPERFLOWSL_[${result.schema.hierarchy}]_${generateCurrentDate()}_${generateUUID()}`;
            const jsonBlob = new Blob([JSON.stringify(res.result, null, 2)], { type: 'application/json' });
            FileSaver.saveAs(jsonBlob, finalName);
          }
        });
      break;
    }
  }
}